import config from '@epi-config';
import { post } from '@epi-helpers/FetchHelpers';

const url = `${config.apiHost}/api/email`;

export function validateEmailRequest(payload: any) {
  return post(`${url}/validate`, payload);
}
